import dayjs from 'dayjs';

export const getShortDaysNames = () => Array(7).fill(null).map((e, i) => dayjs().day(i + 1).format('dd'));
